import { Button } from "@heroui/react";
import { DeferredBoundary } from "@hallyulytics/router";
import { AppFrame, DeferredFilter, MotionBoundary, StreamFallback } from "@hallyulytics/ui";
import { Trans } from "@lingui/react/macro";
import { useLoaderData } from "react-router";
import type { homeLoader } from "../router";

export function HomePage() {
  const data = useLoaderData<typeof homeLoader>();
  return (
    <AppFrame application={data.application} locale={data.locale}>
      <main className="page">
        <MotionBoundary>
          <section className="hero">
            <div>
              <div className="eyebrow">{data.eyebrow}</div>
              <h1>{data.title}</h1>
              <p>{data.description}</p>
              <Button variant="primary">
                <Trans id="enterprise.workspace">Open tenant workspace</Trans>
              </Button>
            </div>
            <div className="panel">
              <DeferredFilter values={data.localSignals} />
            </div>
          </section>
        </MotionBoundary>
        <section className="signals" aria-label="Deferred tenant operations">
          <DeferredBoundary
            value={data.highlights}
            fallback={<StreamFallback label="Loading tenant boundary" />}
            error={<p>Tenant operations are temporarily unavailable.</p>}
          >
            {(items) =>
              items.map((item) => (
                <article className="panel signal" key={item.label}>
                  <span>{item.label}</span>
                  <strong>{item.value}</strong>
                  <small>{item.detail}</small>
                </article>
              ))
            }
          </DeferredBoundary>
        </section>
      </main>
    </AppFrame>
  );
}
